<script>
export default {
    name: 'NotFoundPage',

    page() {
        const title = 'Page not found'
        const description = `The page you requested could not be found on FRISKY.`
        return {
            title,
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },

                { property: 'twitter:title', vmid: 'twitter:title', content: title },
                { property: 'twitter:description', vmid: 'twitter:description', content: description },
            ],
        }
    },
}
</script>

<script setup>
import Layout from '@layouts/main-layout'

defineProps({
    resource: {
        type: String,
        default: '',
    },
})
</script>

<template>
    <Layout>
        <h1 class="title">
            404
            <span v-if="resource">
                {{ resource }}
            </span>
            Not Found
        </h1>
    </Layout>
</template>

<style lang="scss" scoped>
.title {
    text-align: center;
}
</style>
